import { render } from "./AnimatedCircles.vue?vue&type=template&id=19fc07c2&scoped=true"
import script from "./AnimatedCircles.vue?vue&type=script&lang=js"
export * from "./AnimatedCircles.vue?vue&type=script&lang=js"

import "./AnimatedCircles.vue?vue&type=style&index=0&id=19fc07c2&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fc07c2"]])

export default __exports__